import { parseISO } from 'date-fns/parseISO';

import { DATE_FORMAT } from '../i18n/date-formats';

import type { FormatDate } from '@shared/types/i18n/localisation-service';
import type { Stay, StaySerialized } from '@shared/types/utils';

export function serializeStay(
  stay: Stay,
  formatDate: FormatDate,
): StaySerialized {
  return {
    ...stay,
    checkIn: formatDate(stay.checkIn, DATE_FORMAT.NON_LOCALISED_SHORT),
    checkOut: formatDate(stay.checkOut, DATE_FORMAT.NON_LOCALISED_SHORT),
  };
}

export function deserializeStay(staySerialized: StaySerialized): Stay {
  return {
    ...staySerialized,
    checkIn: parseISO(staySerialized.checkIn),
    checkOut: parseISO(staySerialized.checkOut),
  };
}
